/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import loadingIcon from '../../assets/loading3.svg';
import { Rotate, Rotate2, CenteredOverlay } from './styles';

export const LoaderIcon = () => {
  return (
    <Rotate2>
      <img src={loadingIcon} alt="Loader" />
    </Rotate2>
  );
};

export const Loader = () => {
  return (
    <Rotate>
      <img src={loadingIcon} alt="Loader" />
      <h2>Carregando</h2>
    </Rotate>
  );
};
export const CenteredOverlayLoader = () => {
  return (
    <CenteredOverlay>
      <img src={loadingIcon} alt="Loader" />
      <h2>Carregando</h2>
    </CenteredOverlay>
  );
};

export const Loading = React.createElement(Loader);
